import * as React from "react";
import * as main from "../../main.module.scss";
import * as marathon from "./style.module.scss";
export const Marathon = () => {
  return (
    <section className={marathon.marathon}>
      <div className="container">
        <h2 className={main.title}>Марафон для родителей</h2>
        <p className={main.subtitle}>Которым знаком хотя бы один<br/> пункт из списка ниже</p>
        <a href="#decide">
          <ul>
            <li>Не хочет учиться</li>
            <li>Отстает в обучении</li>
            <li>Не делает Д/З</li>
            <li>Плохо запоминает</li>
            <li>Не верит в себя</li>
            <li>Не сдаст экзамены</li>
          </ul>
        </a>
      </div>
    </section>
  );
};
